import { createElement } from "react";
import { colors } from "theme";

import ClientTranslation from "components/ClientTranslation";
import Flex from "components/Flex";
import Text from "components/Text";

import { useClientTranslation } from "hooks/useClientTranslation";

import { messages } from "./variants";

type MessageProps = {
  variant: keyof typeof messages;
};

export const InlineError = ({ variant }: MessageProps) => {
  const { icon, translationKey } = messages[variant];
  const { t } = useClientTranslation();
  return (
    <Flex
      as="div"
      direction="row"
      align="center"
      gap={16}
      px={12}
      py={12}
      style={{
        backgroundColor: colors.red[5],
        borderRadius: "4px",
        border: `1px solid ${colors.red[10]}`,
      }}
    >
      {createElement(icon)}
      <Text as="p" sizeVariant="md">
        {<ClientTranslation i18nKey={translationKey}>{t(translationKey)}</ClientTranslation>}
      </Text>
    </Flex>
  );
};
